import axios from "axios"
import useTickers from "./useTickers"
import { useCallback } from "react"

const error = () => { throw new Error('could not create a new project') }

export default function useProject(isCallable = true) {
    const { checkPrivateCompany } = useTickers(isCallable)

    const checkIfExistProject = useCallback((ticker, projects) =>  projects?.find(project => project.ticker === ticker),[])
    
    const createNewProject = async (ticker, dataset='', column='') => {
        try {
            const newProjectJson = await axios.get(`/api/newProject?ticker=${ticker}${dataset && column && `&dataset=${dataset}&column=${column}`}`)
            const newProject = await newProjectJson.data
            if (newProject.status !== 200) { error() }
            return newProject
        }
        catch { error() }
    }

    const handleNewProject = async (projects, ticker, dataset, column) => {
        let project = checkIfExistProject(ticker, projects)
        if(project) {
             if(dataset?.length && column?.length) {
                const section = await createNewSection(project.uuid, dataset, column)
                project.sections.push(section.uuid)
            }
        }
        else {
            project= await createNewProject(ticker, dataset, column)
        }
        return project
    }

    const createNewSection = async (project_uuid, dataset, column) => {
        try {
            // const resJson = await fetch('/api/newSection', {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify({project_uuid, dataset:[dataset], column:[column]})
            // })
            const resJson = await axios({
                method: 'post',
                url: '/api/newSection',
                data: {project_uuid, dataset:[dataset], column:[column]}
            })
            const res = await resJson.data
            return res
        }
        catch { error() }
    }

    const createSampleGraph = async (datasetValue, columnValue, financialInfo, ticker, sectionId ) => {
        const newGraphReq = {
            dataset: [{datasetValue, columnValue, group: '', agg: ''}],
            ticker,
            financialInfo,
            fileName: "",
            sectionId,
            privateCompany: checkPrivateCompany(ticker),
        }
        // await fetch('/api/getSimpleGraph', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify(newGraphReq)
        // })
        await axios({
            method: 'post',
            url: '/api/getSimpleGraph',
            data: newGraphReq
        })
        return newGraphReq
    }

    return {
        createNewSection,
        createSampleGraph,
        handleNewProject,
        checkIfExistProject
    }
}
